import {toggleBodyScroll} from '../base/utils';

class Popup {
    constructor() {

    }

    static open($popup) {
        // let scrollWidth = window.innerWidth - document.documentElement.clientWidth;

        toggleBodyScroll(true);
        // document.body.style.paddingRight = scrollWidth + 'px';
        document.body.classList.add('popup-open');
        $popup.setAttribute('aria-hidden', 'false');
    }

    static close($popup) {
        toggleBodyScroll(false);
        document.body.classList.remove('popup-open');
        // document.body.style.paddingRight = '';
        $popup.setAttribute('aria-hidden', 'true');
    }
}

export default Popup;
